<template>
  <div class="container mar-b-60">
    <!-- 方法2 -->
    <el-header class="header">投诉建议</el-header>
    <el-main>
      <div class="inputWrap">
        <el-input class="addviseInput" type="textarea" placeholder="请输入你的投诉或者建议" v-model="comment" maxlength="500"
          show-word-limit>
        </el-input>
      </div>
      <div class="title" v-if="userinfo.phone.length <= 0">联系方式</div>
      <div class="numberInput" v-if="userinfo.phone.length <= 0">
        <el-input @input="theInput" type="text" placeholder="请输入09或9开头号码" v-model="phoneNumber" maxlength="11"
          show-word-limit>
        </el-input>
      </div>
      <div class="uploadImg">
        <div class="title">附件</div>
        <el-upload
          class="textLeft"
          ref="upload"
          :action="uploadAction"
          accept="image/jpeg,image/gif,image/png"
          list-type="picture-card"
          :limit="3"
          :data="uploadData"
          :before-upload="beforeUploadFile"
          :on-remove="handleRemove"
          :http-request="uploadFile"
          :on-exceed="handleExceed"
          :auto-upload="true">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}" class="">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file,fileList)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </div>
    </el-main>
    <el-footer>
      <el-button type="success" roun size="medium" class="btn" @click="submitUpload">提交</el-button>
    </el-footer>
    <!-- end图片上传 -->
    <navBar :idx="3"></navBar>
  </div>
</template>

<script>
  import navBar from '@/components/navBar';
  import OSS from 'ali-oss';
  import config from '@/config';
  export default {
    name: 'proposal',
    components: {
      navBar,
    },
    data() {
      return {
        userinfo: {
          id: '',
          phone: '',
          wx_name: '',
        },
        phoneNumber: '',
        comment: '',
        imageUrl: '',
        dialogImageUrl: '',
        uploadData: null,
        dialogVisible: false,
        disabled: false,
        fileList: [],
        uploadAction: config.api_url + 'Proposal/upload',
      }
    },
    mounted() {
      let auth_token = localStorage.getItem('auth_token');
      if (!auth_token) {
        this.$router.push('/mine');
      } else {
        this.$api
          .request('Member/getInfo', {})
          .then(({ data }) => {
            this.userinfo = data;
          })
          .catch(error => {
            this.$message({
              message: error+"获取用户信息失败！",
              type: "warning"
            })
          });
      }
    },
    methods: {
      theInput() {
        this.phoneNumber = this.phoneNumber.replace(/^\.+|[^\d.]/g, '').slice(0, 11);
      },
      beforeUploadFile(file) {
        let extension = file.name.substring(file.name.lastIndexOf('.')+1);
        let size = file.size / 1024 / 1024;
        if(extension != 'jpg' && extension != 'jpeg' && extension != 'png') {
            this.$message({
              message: "只能上传图片",
              type: "warning"
            })
            return new Promise((resolve, reject) => {
              reject('只能上传图片');
            });
        }
        if(size > 2) {
            this.$message({
              message: "文件大小不得超过2Mb",
              type: "warning"
            })
            return new Promise((resolve, reject) => {
              reject('文件大小不得超过2Mb');
            });
        }
      },
      handleRemove(file) {
        let fileList = this.$refs.upload.uploadFiles;
        let index = fileList.findIndex(fileItem => {
          return fileItem.uid === file.uid
        })
        fileList.splice(index, 1)
      },
      // 上传文件
      uploadFile(file) {
        console.log(file);
        let image = file.file;
        let formData = new FormData();
        formData.append("image", image);
        // formData.append("token", this.userinfo.token);
        console.log(image);
        this.$api
          .request(file.action, formData)
          .then(({ data }) => {
            this.fileList.push(data);
          })
          .catch(error => {
            this.handleRemove(file);
            this.$message({
              message: error,
              type: "error"
            })
          });
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      submitUpload() {
        if (this.comment.length <= 0) {
          this.$message({
            message: "请输入建议内容",
            type: "error"
          })
          return;
        }
        if (!this.userinfo.phone && !/^((09|9)\d{9})$/.test(this.phoneNumber)) {
          this.$message({
            message: '请输入正确的电话号码!',
            type: 'error',
          });
         return;
        }
        let formData = new FormData();
        formData.append("comment", this.comment);
        formData.append("phoneNumber", this.phoneNumber);
        formData.append("images", this.fileList);
        this.$api
          .request(config.api_url + 'Proposal/submit', formData)
          .then(({ data, msg }) => {
            this.$alert(msg, '提示').then(() => {
              this.$router.push('/mine');
            });
          })
          .catch(error => {
            this.$message({
              message: error+"获取用户信息失败！",
              type: "warning"
            })
          });
      }
    }
  }
</script>

<style scoped lang="less">
  @import url("../../static/less/mine.less");

  .container {
    max-width: 750px;
    padding: 0 15px;
  }

  .none {
    display: none !important;
  }

  .inputWrap {
    height: 200px;
    // margin-bottom: 20px;
    /deep/ textarea.el-textarea__inner {
      height: 200px;
      resize: none;

    }
  }

  .uploadImg {
    margin-bottom: 20px;

    .textLeft {
      text-align: left;
    }
  }

  .title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 1.5;
    padding: 10px 10px 10px 0;

  }

  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #E43;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .btn {
    width: 50%;
    padding: 15px;
    font-size: 16px;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
  }

  .el-upload-list__item-thumbnail {}

  .mar-b-60 {
    margin-bottom: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/page/proposal.vue